module.exports = __webpack_public_path__ + "static/media/vehicules.d9e21c47.webp";